import React from 'react';
import styles from './TextButton.module.scss';

interface IPropTypes {
  text: string;
  onClick: () => void;
}

export const TextButton: React.FC<IPropTypes> = React.memo(
  ({ text, onClick }) => {
    return (
      <button className={styles.TextButton} onClick={onClick}>
        {text}
      </button>
    );
  }
);
TextButton.displayName = 'TextButton';
